function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.429 1.286c0 .304-.064.594-.179.857H6c.237 0 .429.192.429.428v1.715H6c-.947 0-1.714.767-1.714 1.714v.429H2.57A.429.429 0 012.143 6V3.25a2.136 2.136 0 01-1.286.136V6c0 .947.768 1.714 1.714 1.714h1.715V9.43c0 .946.767 1.714 1.714 1.714h2.614a2.154 2.154 0 01.136-1.286H6a.429.429 0 01-.429-.428V7.714H6c.947 0 1.714-.767 1.714-1.714v-.429H9.43c.236 0 .428.192.428.429v2.75a2.136 2.136 0 011.286-.136V6c0-.947-.768-1.714-1.714-1.714H7.714V2.57C7.714 1.625 6.947.857 6 .857H3.386c.028.139.043.282.043.429zm3 4.285V6A.429.429 0 016 6.429h-.429V6c0-.237.192-.429.429-.429h.429zM2.57 1.286a1.286 1.286 0 11-2.571 0 1.286 1.286 0 012.571 0zM12 10.714a1.286 1.286 0 11-2.571 0 1.286 1.286 0 012.571 0zm0-9.428a1.286 1.286 0 11-2.571 0 1.286 1.286 0 012.571 0zm-9.429 9.428a1.286 1.286 0 11-2.571 0 1.286 1.286 0 012.571 0z",
  fill: "#8F90A6"
});

function SvgCollaboratorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCollaboratorIcon;